import { get } from 'lodash'
import React from 'react'
import styled from 'styled-components'
import { FiChevronRight } from 'react-icons/fi'
import { MdError } from 'react-icons/md'
import { Cell } from 'react-sticky-table'

import { InputGroup } from './input-group'
import { revenueType, type } from '../../../constants'
import { FONTS } from '../../../../../../../constants'

const findCrIndex = (crRevenue, cr_id) => {
  const index = crRevenue.findIndex(c => c.cr_id === cr_id)
  return `CR-${index + 1}`
}

export const ProjectDetail = React.memo((props) => {
  const {
    data,
    isExpand,
    allocation_id,
    crRevenue,
    incompletedList,
    handleExpandTable,
  } = props
  const showWarning = incompletedList[allocation_id]
  const revenue = get(data, 'revenue', '-')
  const percentage = get(data, '_sumTypePercent', '-')
  const productName = get(data, '_product_name', '-') || 'Untitled'
  const name = data.type === 'CR' ? revenueType[data.cr_type].name : productName

  return (
    <Cell>
      <Root>
        <StickyHeader onClick={ () => handleExpandTable(allocation_id) }>
          <WarningCol>
            { showWarning && <MdError style={ { color: '#F0C34E' } } /> }
          </WarningCol>
          <ProjectCol>
            <TagWrapper active={ isExpand }>
              <FiChevronRight
                id='arrow'
                style={ { color: '#C4C4C4', marginRight: 12 } }
              />
              <Tag color={ revenueType[data.type] ? revenueType[data.type].color : '' }>
                <StickyText>{ data.type === 'CR' ? findCrIndex(crRevenue, data.cr_id) : revenueType[data.type].name }</StickyText>
              </Tag>
            </TagWrapper>
          </ProjectCol>
          <AvailableCol>
            { name !== '-' && data.type !== type.SERVICE &&
            <React.Fragment>
              <Dot color={ revenueType[data.type] ? revenueType[data.type].color : '' } />
              <AvailableText>{ name }</AvailableText>
              <div className='tooltip'>{ name }</div>
            </React.Fragment>
            }
          </AvailableCol>
          <RevenueCol>
            <HeaderText>Revenue</HeaderText>
            <HeaderNumber>{`฿ ${revenue}`}</HeaderNumber>
          </RevenueCol>
          <PercentageCol>
            <HeaderText>Percentage</HeaderText>
            <HeaderNumber>{`${percentage} %`}</HeaderNumber>
          </PercentageCol>
        </StickyHeader>
        <StickyBody active={ isExpand }>
          <InputWrapper>
            { data.lobs.map((i, k) => (
              <InputGroup
                key={ k }
                id={ k }
                { ...props }
              />
            ))}
          </InputWrapper>
        </StickyBody>
      </Root>
    </Cell>
  )
})

const Root = styled.div`
  margin-bottom: 8px;
`

const InputWrapper = styled.div`
`

const StickyHeader = styled.div`
  width: 460px;
  height: 45px;
  display: flex;
  background: #FFFFFF;
  cursor: pointer;
`

const StickyBody = styled.div`
  width: 460px;
  background: #F9F9F9;
  display: ${p => (p.active ? 'block' : 'none')};
`

const WarningCol = styled.div`
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ProjectCol = styled.div`
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px 0 0;
`

const AvailableCol = styled.div`
  width: 180px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 6px;
  position: relative;

  .tooltip {
    width: 100%;
    min-width: 200px;
    max-width: 300px;
    position: absolute;
    top: 40px;
    background-color: #fff;
    font-family: ${FONTS.GOTHAM};
    font-size: 12px;
    padding: 5px;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.3);
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
  }

  :hover {
    .tooltip {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const RevenueCol = styled.div`
  width: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0 6px;
`

const PercentageCol = styled.div`
  width: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0 6px;
`

const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  
  #arrow {
    transform: ${p => (p.active ? 'rotate(90deg)' : 'rotate(0deg)')};
    transition: all 0.3s;
  }
`

const Tag = styled.div`
  height: 24px;
  width: 82px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => p.color};
  border-radius: 4px;

  span {
      color: #FFFFFF;
  }
`

const StickyText = styled.span`
  height: 14px;
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #C4C4C4;
`

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background: ${p => p.color};
  border-radius: 50%;
  margin-right: 4px;
`

const AvailableText = styled.span`
  height: 14px;
  flex: 1;
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #9BA3AB;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #C4C4C4;
`

const HeaderNumber = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: 12px;
  color: #1A1A17;
`




// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/project-detail/index.js